import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nopage404',
  templateUrl: './nopage404.component.html',
  styleUrls: ['./nopage404.component.scss']
})
export class Nopage404Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
